import type { IUser } from "~/providers/interfaces";
import Photo from "~/assets/def-photo.svg";
import { classNames, getImagePath } from "~/utils/utils";

import "./style.less";
import { trans } from "~/utils/trans";

export interface IBadgeOnClick {
	emailClick: boolean
}

interface IBadge {
	userData: IUser | null;
	onClick?: (data: IBadgeOnClick) => void;
}

export default function Badge({
	userData = null,
	onClick = () => {},
} : IBadge) {
	const className = classNames([
		"img-holder",
		userData?.email ? "" : "blurred",
	]);

	function badgeOnClick() {
		onClick({
			emailClick: !!userData?.email,
		});
	}

	return <div className="badge badge-header" onClick={badgeOnClick}>
		<div className={className}>
			<img src={userData.foto_uri ? getImagePath(userData.foto_uri) : Photo} alt="" className={userData.foto_uri ? "" : "badge__defaultImg"} />
		</div>
		<h2>
			{userData?.email || trans("menu.notLogged")}
		</h2>
	</div>;
}
